module.exports = __webpack_public_path__ + "static/img/fullscreen_exit.1946ed78.svg";